const Flickity = require('flickity-fade');

new Flickity('[data-quote="flickity"]', {
  arrowShape: 'M 35,50 L 65,100 L 70,100 L 40,50  L 70,0 L 65,0 Z',
  fade: true,
  setGallerySize: false,
  cellAlign: 'left',
  wrapAround: true,
});

(function($) {
  const $body = $('body');

  $body.find('[data-type="positions"]').on('click', function(e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $body.find('[data-type="openOpportunities"]').offset().top - $body.find('.main_site_header').height() + 1,
    }, 1000);

    if (window.history && window.history.pushState) {
      window.history.pushState(true, this.innerHTML, this.href);
    }
  });
}(window.jQuery || window.Zepto || window.$));
